import React from 'react';
import { TestLogicFactory } from '../../eye-test/logic/test-logic-factory';
import { ContrastTestLogic } from '../../eye-test/logic/contrast-test-logic';
import { ContrastTestRating } from '../../eye-test/logic/contrast-test-data';
import '../styles/result.scss';

export const ResultContrastTest: React.FunctionComponent = () => {
	const testLogic = TestLogicFactory.getInstanceOf('contrast-test-logic') as ContrastTestLogic;
	const result = testLogic.getContrastTestObject();


	let resEl = (
		<>
			Ihre Kontrastsehleistung ist möglicherweise nicht optimal. Bitte vereinbaren Sie einen <strong> kostenlosen
			Termin</strong> mit unserem Team.
		</>
	);

	if (result.rating === ContrastTestRating.NE) {
		resEl = <> Ihr Kontrastsehen ist <strong>nicht eingeschränkt</strong>.</>;
	} else if (result.rating === ContrastTestRating.GE) {
		resEl = <> Ihr Kontrastsehen ist <strong> gering eingeschränkt</strong>.</>;
	} else if (result.rating === ContrastTestRating.ME) {
		resEl = <> Ihr Kontrastsehen ist <strong> eingeschränkt</strong>.</>;
	} else if (result.rating > ContrastTestRating.SE) {
		resEl = <> Ihr Kontrastsehen ist <strong> stark eingeschränkt</strong>.</>;
	}


	return (
		<>
			<p className={'standard-text result-contrast'}>Ihre Kontrastschwelle liegt bei {result.percentage} %.</p>
			<p className={'standard-text result-contrast'}>{resEl}</p>
		</>
	);
};

